
export default {
  name: 'Footer',
  components: {
    EditUI: () =>
      import(/* webpackChunkName: 'EditUI' */ '~/components/editUi/EditUi.vue'),
  },

  computed: {
    isShowOriginalLogo() {
      return (
        _.isEmpty(_.get(this.getBrending, 'footer.logoColor')) ||
        _.get(this.getBrending, 'footer.logoColor') === 'blue'
      )
    },
  },
}
